import React, { useState } from 'react';
import { Fragment } from 'react';
//import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import {
  Container,
  Dropdown,
  Icon,
  Image,
  Menu,
  Sidebar,
} from 'semantic-ui-react';
//import SignedInMenu from './SignedInMenu';
//import SignedOutMenu from './SignedOutMenu';

function NavBarMobile({
  children,
  leftMenuItems,
  onPusherClick,
  onToggle,
  rightMenuItems,
  visible,
}) {
  //  const { authenticated } = useSelector((state) => state.auth);

  return (
    <Sidebar.Pushable>
      <Sidebar
        as={Menu}
        animation='overlay'
        icon='labeled'
        inverted
        //items={leftMenuItems}
        vertical
        visible={visible}
      >
        {leftMenuItems.map((item) => {
          return item.content && item.content instanceof Array ? (
            <Dropdown item text={item.text} key='key1' icon={item.icon}>
              <Dropdown.Menu>
                <Dropdown.Item>Item 1</Dropdown.Item>
                <Dropdown.Item>Item 2</Dropdown.Item>
                <Dropdown.Item>Item 3</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <Menu.Item as='a' href={item.href} key={item.key}>
              <Icon name={item.icon} />
              {item.content}
            </Menu.Item>
          );
        })}
      </Sidebar>
      <Sidebar.Pusher
        dimmed={visible}
        onClick={onPusherClick}
        style={{ minHeight: '100vh' }}
      >
        <Menu fixed='top'>
          <Menu.Item>
            <Image as={NavLink} to='/' size='mini' src='/assets/logo.png' />
          </Menu.Item>
          <Menu.Item onClick={onToggle}>
            <Icon name='sidebar' />
          </Menu.Item>
          {/* <Menu.Menu position='right'>
            {rightMenuItems.map((item) => (
              <Menu.Item {...item} />
            ))}
          </Menu.Menu> */}
          {/* {authenticated ? <SignedInMenu /> : <SignedOutMenu />} */}
        </Menu>
        {children}
      </Sidebar.Pusher>
    </Sidebar.Pushable>
  );
}

const NavBarDesktop = (props) => {
  const { leftMenuItems } = props;
  //  const { authenticated } = useSelector((state) => state.auth);
  return (
    <Menu fixed='top'>
      <Menu.Item>
        <Image as={NavLink} to='/' size='mini' src='/assets/logo.png' />
      </Menu.Item>

      {/* {leftMenuItems.map((item) => (
        <Menu.Item {...item} />
      ))} */}
      {leftMenuItems.map((item) => {
        return item.content && item.content instanceof Array ? (
          <Dropdown
            button
            item
            className='icon'
            floating
            labeled
            icon='world'
            key={item.key}
            options={item.content}
            //search
            text='Select Language'
          >
            {/* <Dropdown.Menu>
              {item.content.map((dd) => (
                <Dropdown.Item as={dd.as} href={dd.href} key={dd.key}>
                  {dd.icon ? (
                    <Fragment>
                      <span className={`flag-icon flag-icon-${dd.icon}`} />{' '}
                      {dd.content}
                    </Fragment>
                  ) : (
                    dd.content
                  )}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu> */}
          </Dropdown>
        ) : (
          <Menu.Item as='a' href={item.href} key={item.key}>
            <Icon name={item.icon} />
            {item.content}
          </Menu.Item>
        );
      })}

      {/* <Menu.Menu position='right'>
        {rightMenuItems.map((item) => (
          <Menu.Item {...item} />
        ))}
      </Menu.Menu> */}

      {/* {authenticated ? <SignedInMenu /> : <SignedOutMenu />} */}
    </Menu>
  );
};

const NavBarChildren = (props) => (
  <Container style={{ marginTop: '3.5em' }}>{props.children}</Container>
);

export default function ResponsiveNavBar({
  Media,
  children,
  leftMenuItems,
  rightMenuItems,
}) {
  const [visible, setVisible] = useState(false);

  function handlePusher() {
    if (visible) setVisible(false);
  }

  function handleToggle() {
    setVisible(!visible);
  }

  return (
    <Fragment>
      <Media at='mobile'>
        <NavBarMobile
          leftMenuItems={leftMenuItems}
          onPusherClick={handlePusher}
          onToggle={handleToggle}
          rightMenuItems={rightMenuItems}
          visible={visible}
        >
          <NavBarChildren>{children}</NavBarChildren>
        </NavBarMobile>
      </Media>

      <Media greaterThan='mobile'>
        <NavBarDesktop
          leftMenuItems={leftMenuItems}
          rightMenuItems={rightMenuItems}
        />
        <NavBarChildren>{children}</NavBarChildren>
      </Media>
    </Fragment>
  );
}
